module.exports = __webpack_public_path__ + "static/media/Logo.8041e0f8.png";